import { Injectable } from '@angular/core';
import Fuse from 'fuse.js'
@Injectable({
  providedIn: 'root',
})
export class SearchService {
  private threshold: number = 0.3;
  constructor() {}

  filterData(data: any[], searchTerm: string, keys: any[]) {
    // console.log(data, searchTerm, keys);
    searchTerm = searchTerm.toLowerCase();
    return data.filter((item) => {
      return keys.some((column) => {
        return item[column.id]?.toString().toLowerCase().includes(searchTerm);
      });
    });
  }

  fuseFilterData(data:any[],searchTerm: string, keys: any[],minMatchLength:number=3) : any[]{
    if(searchTerm.length < minMatchLength)return data;
    // const searchColumns = keys.map(k=>k.id);
    const options = {
      keys: keys,
      threshold: this.threshold,
      minMatchCharLength: minMatchLength
    }
    const fuse = new Fuse(data,options);
    const result = fuse.search(searchTerm).map(r=>r.item);
    console.log('fuzzy: ',result);
    return result;
  }
}
